import callAPI from 'config/api';

const ROOT_API = process.env.NEXT_PUBLIC_API;
const API_VERSION = 'api/v1';
const token = process.env.NEXT_PUBLIC_TOKEN;

export async function getAccount() {
  const url = `${ROOT_API}/hub/${API_VERSION}/accounts`;

  return callAPI({
    url,
    method: 'GET',
    token: true,
    locationId: true,
  });
}

export async function updateAccount(data) {
  const url = `${ROOT_API}/hub/${API_VERSION}/accounts`;

  return callAPI({
    url,
    method: 'PUT',
    token: true,
    locationId: true,
    data,
  });
}

export async function updatePassword(data) {
  const url = `${ROOT_API}/auth/${API_VERSION}/change-password`;

  return callAPI({
    url,
    method: 'POST',
    token: true,
    locationId: true,
    data,
  });
}

export async function deleteAccount(data = false) {
  const url = `${ROOT_API}/hub/${API_VERSION}/accounts`;

  return callAPI({
    url,
    method: 'DELETE',
    token: true,
    locationId: true,
    data,
  });
}
